<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-subject-student
            :resources="resources"
            :subjectId="subject"
            :loadedSubject="loadedSubject"
          ></list-subject-student>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import ListSubjectStudent from "../../Components/Academic/Subject/ListSubjectStudent.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

export default {
  props: ["subject", "title"],

  components: {
    BaseLayout,
    ListSubjectStudent,
    IonGrid,
    IonRow,
    IonCol,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      //   title: this.title,
      backLink: "academic",
      reloadable: true,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["subjectStudent/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
    loadedSubject() {
      const subjects = this.$store.getters["subject/resources"];
      const subject = subjects.data.filter((item) => {
        return item.id == this.subject;
      });
      return subject[0];
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh) {
      await this.$store.dispatch("subjectStudent/resources", {
        refresh: refresh,
        resourceId: this.subject,
      });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("subjectStudent/resources", {
        refresh: true,
        resourceId: this.subject,
      });
      if (event) {
        event.target.complete();
      }
    },
    async loadSubject() {
      await this.$store.dispatch("subject/resources", { refresh: false });
    },
  },

  created() {
    this.fetch(true);
    this.loadSubject();
  },
};
</script>

<style scoped>
</style>
